// Continuous, fixed blue/cyan ambient lighting shared by every page (stays put while scrolling).
export default function AmbientGlow({ variant = "default" }) {
  return (
    <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden" aria-hidden="true" data-testid={`ambient-${variant}`}>
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_-10%,rgba(77,166,255,0.14),transparent_55%),radial-gradient(ellipse_at_100%_100%,rgba(34,211,238,0.07),transparent_50%),radial-gradient(ellipse_at_0%_60%,rgba(38,128,235,0.07),transparent_45%)]" />
      <div className="absolute top-[-15%] left-1/2 -translate-x-1/2 w-[900px] h-[700px] bg-[#4da6ff] rounded-full blur-[180px] opacity-[0.06] animate-glow" />
      <div className="absolute bottom-[-20%] right-[-10%] w-[600px] h-[600px] bg-[#22d3ee] rounded-full blur-[170px] opacity-[0.03] animate-glow" style={{ animationDelay: "3s" }} />
    </div>
  );
}
